import { render, staticRenderFns } from "./FictionSortBooks.vue?vue&type=template&id=459b83eb&"
import script from "./FictionSortBooks.vue?vue&type=script&lang=js&"
export * from "./FictionSortBooks.vue?vue&type=script&lang=js&"
import style0 from "./FictionSortBooks.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports